import React from 'react';
import { RIGHTARROW_ICON } from '../../../utills/image-constant';

const TableHeading = ({ TableHeading, firstData = "", icon, secondData = "", thirdData = "", iconshow, className, onFirstDataClick, secondclassName }) => {
  return (
    <div className={`${TableHeading} d-flex flex-wrap px-3 tableheading }`}>
      <h5 className={`mb-0 cursor-pointer ${className}`} onClick={onFirstDataClick}>{firstData}</h5>
      {secondData && icon && <img src={icon} alt="icon" className="headingarrowicon" />}
      <h5 className={`mb-0 cursor-pointer ${secondclassName}`} onClick={onFirstDataClick}>{secondData}</h5>
      {iconshow && <img src={RIGHTARROW_ICON} alt="icon" className="icon ms-1 headingarrowicon" />}
      <h5 className='mb-0 cursor-pointer'>{thirdData}</h5>
    </div>
  );
};
export default TableHeading;
